import { Badge } from "@/components/ui/badge";
import type { McpPrompt } from "@/lib/hooks/useMcpInspector";
import type { SelectionGridItem } from "../shared/components";
import { SelectionGrid } from "../shared/components";

export interface PromptSelectorProps {
  prompts: McpPrompt[] | null;
  selectedPrompt: string | null;
  onPromptSelect: (promptName: string | null) => void;
  isLoading: boolean;
  error: Error | null;
}

export function PromptSelector({
  prompts,
  selectedPrompt,
  onPromptSelect,
  isLoading,
  error,
}: PromptSelectorProps) {
  return (
    <SelectionGrid
      items={(prompts as SelectionGridItem[]) || []}
      selectedItem={selectedPrompt}
      onItemSelect={onPromptSelect}
      isLoading={isLoading}
      error={error?.message || null}
      emptyMessage="No prompts available"
      errorMessage="Failed to load prompts"
      renderItemContent={(item) => {
        const prompt = item as unknown as McpPrompt;
        return (
          <>
            <div className="font-semibold text-foreground group-hover:text-primary transition-colors">
              {prompt.name}
            </div>
            <div className="text-sm text-muted-foreground mt-1 line-clamp-2">
              {prompt.description || "No description provided"}
            </div>
            {prompt.arguments && prompt.arguments.length > 0 && (
              <div className="flex flex-wrap gap-1 mt-2">
                {prompt.arguments.map(
                  (arg: { name: string; required?: boolean }) => (
                    <Badge key={arg.name} variant="outline" className="text-xs">
                      {arg.name}
                      {arg.required && (
                        <span className="text-destructive ml-1">*</span>
                      )}
                    </Badge>
                  ),
                )}
              </div>
            )}
          </>
        );
      }}
    />
  );
}
